import styled from 'styled-components';
import { color, spacing } from 'theme';

export const StyledIndexBox = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  padding: ${spacing('md')} ${spacing('md')};
  font-size: 1.1rem;
  margin-bottom: 32px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
  min-height: 220px;
  box-sizing: border-box;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const StyledIndexContent = styled.div`
  overflow-y: auto;
  flex: 1 1 auto;
  gap: ${spacing('xl')};

  .dash {
    flex: 0 0 auto;
    width: 18px;
    font-weight: 400;
    font-family: inherit;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-bottom: ${spacing('sm')};

    & > li {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      margin-top: ${spacing('sm')};
      color: ${color('emerald_750')};

      & > a {
        text-decoration: none;
        word-break: break-word;
        line-height: 1.5;
        font-size: 1.1rem;
        color: ${color('emerald_750')};
      }
    }
  }
`;
